var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"white--text",attrs:{"icon":"","large":"","color":"blue-grey"},on:{"click":_vm.signout}},'v-btn',attrs,false),on),[_c('v-icon',{attrs:{"small":""}},[_vm._v(" logout ")])],1)]}}])},[_c('span',[_vm._v("Sign out")])])}
var staticRenderFns = []

export { render, staticRenderFns }